import(/* webpackMode: "eager" */ "/var/www/academy-frontend/src/components/common/image/CommonImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/pages/home/aboutUs/AboutUs.js");
